import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/msalConfig';
import * as microsoftTeams from '@microsoft/teams-js';
import ISILogo from '../images/ISILogo.png';

function LoginPage({ isInTeams = false }) {
  const { instance } = useMsal();

  const handleLogin = async () => {
    if (isInTeams) {
      // Use Teams popup authentication
      try {
        // Use MSAL popup (Teams allows popups opened via its SDK)
        const response = await instance.loginPopup(loginRequest);
        console.log('Teams login successful:', response.account?.username);
      } catch (error) {
        console.error('Teams login failed:', error);
      }
    } else {
      // Standard redirect flow for standalone
      instance.loginRedirect(loginRequest).catch((error) => {
        console.error('Login failed:', error);
      });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          {/* Logo/Header */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center mb-4 bg-gray-700 rounded-lg px-6 py-3">
              <img src={ISILogo} alt="ISI Logo" className="h-12 w-auto" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Operations Archive Mailbox Browser</h1>
            <p className="text-gray-500 mt-2">Email Archive Viewer</p>
          </div>

          {/* Login Section */}
          <div className="space-y-6">
            <div className="text-center">
              <p className="text-sm text-gray-600 mb-6">
                Sign in with your organization account to access the email archive.
              </p>
            </div>

            {/* Microsoft Login Button */}
            <button
              onClick={handleLogin}
              className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 hover:shadow transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              {/* Microsoft Logo */}
              <svg className="w-5 h-5" viewBox="0 0 21 21">
                <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
              </svg>
              <span className="text-gray-700 font-medium">Sign in with Microsoft</span>
            </button>
          </div>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-400 text-center">
              Protected by Azure Active Directory
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
